export const getActiveUser = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const userActive = urlParams.get('u')

  return userActive
}
